module.exports = __webpack_public_path__ + "static/mcgill.ab8f4b7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/highered_logos/mcgill.png
// module id = 2188
// module chunks = 61762850755587